module.exports = __webpack_public_path__ + "img/30_4.3b784ece.png";